import { render, staticRenderFns } from "./DictionaryStandards.vue?vue&type=template&id=151432c6&"
import script from "./DictionaryStandards.vue?vue&type=script&lang=js&"
export * from "./DictionaryStandards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports